module.exports = __webpack_public_path__ + "img/mallDetailsPageSettings.96fa9ae8.png";